import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {Subscription} from "rxjs/Subscription";
import {SettingService} from "../../store/setting/setting.service";
import {ContactService} from "../../store/contact/contact.service";
import {ContactEntity} from "../../store/contact/contact.entity";

/**
 * Generated class for the SettingActiveContractorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-active-contractor',
  templateUrl: 'setting-active-contractor.html',
})
export class SettingActiveContractorPage {

  public settings: any
  public contractors: Array<any>;
  public hasCloseButton: boolean = false;
  private _customerSubscription: Subscription;
  private _settingSubscription: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl: ViewController,
              private settingService: SettingService,
              private contactService: ContactService) {

    this.hasCloseButton = this.navParams.get('hasCloseButton');
  }

  ionViewWillEnter() {
    this._settingSubscription = this.settingService.get()
      .subscribe(settingDocument => this.settings = settingDocument);

    this._customerSubscription = this.contactService.getAllByType(2)
      .subscribe(contractors => this.contractors = contractors);
  }

  ionViewWillLeave() {
    this._customerSubscription.unsubscribe();
    this._settingSubscription.unsubscribe();
  }

  public setAsActive(contractor: ContactEntity): void {
    if (this.settings.activeContractor !== contractor._id) {
      this.settings.activeContractor = contractor._id;
      this.settingService.set(this.settings, false);
    }
    this.viewCtrl.dismiss(contractor);
    // this.navCtrl.pop(contractor);
  }

  public close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-active-contractor/setting-active-contractor.ts